 class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

   connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('custom-product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }

            if (html.querySelector('.card')) {
              this.classList.add('product-recommendations--loaded');
            }
            this.SliderListner();

          })
          .catch((e) => {
            console.error(e);
          });
      };

     new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);

     console.log( "selector js" ,  this.next_btn )


    }

   SliderListner() {
     const slider = this.querySelector('swiper-container')
     this.querySelector('.next-slide').addEventListener('click', () => {
      slider.swiper.slideNext()
     })

     this.querySelector('.previous-slide').addEventListener('click', () => {
      slider.swiper.slidePrev()
     })
     const style = document.createElement('style');
     style.textContent = `
       .swiper-scrollbar-drag {
         background-color: rgb(244, 42, 55) !important;
       }
  .swiper-horizontal>.swiper-scrollbar, .swiper-scrollbar.swiper-scrollbar-horizontal {
  position: unset !important;
  margin-top:3rem;

  }

       `;
     slider.shadowRoot.appendChild(style);
  }
  }

  customElements.define('custom-product-recommendations',ProductRecommendations)